import { Routes, Route, Navigate } from 'react-router-dom';
import ErrorBoundary from './components/ErrorBoundary';
import ProtectedRoute from './components/ProtectedRoute';
import LandingPage from './pages/LandingPage';
import Login from './pages/Login';
import Register from './pages/Register';
import Dashboard from './pages/Dashboard';
import Upload from './pages/Upload';
import Questionnaire from './pages/Questionnaire';
import TaxReview from './pages/TaxReview';
import TaxInputs from './pages/TaxInputs';
import Settings from './pages/Settings';
import News from './pages/News';
import TaxReference from './pages/TaxReference';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService';
import ServiceDisclosures from './pages/ServiceDisclosures';
import SecurityOverview from './pages/SecurityOverview';
import useAppInit from './hooks/useAppInit';

// Public mode: when true, login/register are disabled (for Vercel/production deploy)
// Set to false for local development with full app access
const PUBLIC_MODE = import.meta.env.VITE_PUBLIC_MODE === 'true';

function App() {
  useAppInit();

  return (
    <ErrorBoundary>
    <Routes>
      <Route path="/" element={<LandingPage />} />
      {PUBLIC_MODE ? (
        <>
          <Route path="/login" element={<Navigate to="/" replace />} />
          <Route path="/register" element={<Navigate to="/" replace />} />
        </>
      ) : (
        <>
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
        </>
      )}
      <Route path="/updates" element={<News />} />
      <Route path="/updates/:slug" element={<News />} />
      <Route path="/tax-reference" element={<TaxReference />} />
      <Route path="/privacy" element={<PrivacyPolicy />} />
      <Route path="/security" element={<SecurityOverview />} />
      <Route path="/terms" element={<TermsOfService />} />
      <Route path="/disclosures" element={<ServiceDisclosures />} />

      <Route element={<ProtectedRoute />}>
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/upload" element={<Upload />} />
        <Route path="/questionnaire" element={<Questionnaire />} />
        <Route path="/review" element={<TaxReview />} />
        <Route path="/inputs" element={<TaxInputs />} />
        <Route path="/settings" element={<Settings />} />
      </Route>

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
    </ErrorBoundary>
  );
}

export default App;
